/**
 * Models for Recently Viewed API integration
 */

export interface RecentlyViewedItem {
  modelType: string;
  modelId: string;
  viewedAt: string;
  modelData?: any; // The actual model data (Contact, FundOpportunity, etc.)
}

export interface RecentlyViewedRequest {
  modelType: string;
  modelId: string;
}

export interface RecentlyViewedResponse {
  data: RecentlyViewedItem;
}

export interface RecentlyViewedListResponse {
  data: RecentlyViewedItem[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
    hasNextPage: boolean;
    hasPreviousPage: boolean;
  };
}

export interface RecentlyViewedFilters {
  modelType?: string;
  page?: number;
  limit?: number;
}

// Common model types used in the system
export enum ModelType {
  CONTACT = 'CONTACT',
  FUND_OPPORTUNITY = 'FUND_OPPORTUNITY',
  INVESTOR = 'INVESTOR',
  INVESTMENT_ENTITY = 'INVESTMENT_ENTITY',
  ADMIN_USER = 'ADMIN_USER',
  EOI = 'EOI',
  ALLOCATION = 'ALLOCATION',
  USER = 'USER',
  GLOBAL_CONFIG = 'GLOBAL_CONFIG',
}
